import { render } from "./CreateBanner.vue?vue&type=template&id=093c2c06&scoped=true"
import script from "./CreateBanner.vue?vue&type=script&lang=js"
export * from "./CreateBanner.vue?vue&type=script&lang=js"

import "./CreateBanner.vue?vue&type=style&index=0&id=093c2c06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093c2c06"]])

export default __exports__